module.exports = __webpack_public_path__ + "static/media/BTC-icon.481b696a.svg";